import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { isNotNullable } from '@spartacus/core'
import { filter, map, skip } from 'rxjs/operators'
import { OrderHistoryService } from '@spartacus/order/core'

@Injectable({
  providedIn: 'root'
})
export class OrderDetailsGuard implements CanActivate {
  notFound = this.router.parseUrl('/not-found')

  constructor (private router: Router,
               protected orderService: OrderHistoryService) { }

  canActivate (router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.orderService.loadOrderDetails(router?.params?.orderCode)
    return this.orderService.getOrderDetails().pipe(
      skip(1),
      filter(isNotNullable),
      map(orderDetails => !!Object.keys(orderDetails).length || this.notFound)
    )
  }
}
